import { chromeSearchInputClearStyles } from "./chromeSearchInputClearStyles";
import { reactDayPickerStyles } from "./reactDayPicker";
import { rootStyles } from "./root";
import { globalScrollbarStyles } from "./scrollbar";

export const styles = {
  global: {
    ...rootStyles,
    ...reactDayPickerStyles,
    ...globalScrollbarStyles,
    ...chromeSearchInputClearStyles,

    // When you import Chakra, it include a css reset.
    // One of the css selectors sets outline and boxShadow to none, for:
    // [data-js-focus-visible] :focus:not([data-focus-visible-added])
    // These selectors exist from the focus-visible polyfill which we use.
    //
    // The reset works fine most of the time, but it causes a glitch when you
    // focus on the popover, causing the boxShadow to disappear. We fix it by
    // applying a more specific css selector to ensure we still get the boxShadow.
    "[data-js-focus-visible] .chakra-popover__content:focus:not([data-focus-visible-added])":
      {
        boxShadow: "var(--chakra-shadows-md)",
      },
  },
};
